import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Helmet } from 'react-helmet-async';

/**
 * Admin Portal Not Found Page
 * 
 * Displayed when V2_ENABLE_ADMIN_PORTAL=false
 * Returns a standard 404 to avoid advertising the endpoint.
 */
export default function AdminNotFound() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Page Not Found | Canadian Document Services</title>
      </Helmet>
      
      <div data-testid="admin-not-found" className="min-h-[60vh] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold text-[hsl(215,50%,23%)] mb-4">404</h1>
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/">
            <Button className="gov-btn-primary">
              Return Home
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
}
